import React, { useState } from 'react';
import BaseModel from '../../BaseModal';
import { FlexWrapperCenter, GapView } from '../../styles/WrapperStyles';
import styled from 'styled-components';

const ParentDiv = styled.div`
  width: 445px;
  height: 197px;
  border-radius: 20px;
`;

const TextView = styled.div`
  font-family: 'Gilory-Bold';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
`;

const InputText = styled.input`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    transform: scale(1.5);
    opacity: 1;
    margin-right: 20px;
  }
  width: 300px;
  height: 90%;
  border-radius: 30px;
  border: solid 1px #d7d7d7;
  background-color: #ffffff;
  border: none;
  padding-left: 20px;
  font-size: 20px;
`;

const GoButton = styled.button`
  width: 60px;
  height: 80%;
  background-color: #484848;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 30px;
`;

const FlexParent = styled(FlexWrapperCenter)`
  width: 346px;
  height: 60px;
  border-radius: 30px;
  border: solid 1px #d7d7d7;
  background-color: #ffffff;
  overflow: hidden;
  margin-left: 50px;
  align-items: center;
`;

const PageModal = (props) => {
    const [state, setState] = useState({
        page: props.page
    });

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            props.goToPage(state.page);
        }
    };

    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                <GapView height="20px" />
                <FlexWrapperCenter>
                    <TextView>Change page to</TextView>
                </FlexWrapperCenter>
                <GapView height="50px" />
                <FlexParent>
                    <InputText
                        type="number"
                        value={state.page}
                        onChange={(e) => {
                            setState({ page: e.target.value });
                        }}
                        onKeyPress={handleKeyPress}
                    />
                    <GoButton
                        onClick={() => {
                            props.goToPage(state.page);
                        }}
                    >
                        Go
                    </GoButton>
                </FlexParent>
            </ParentDiv>
        </BaseModel>
    );
};

export default PageModal;
